import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "children"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var LayoutFooter = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-layout-footer',
      className,
      children
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("footer", _extends({
    ref: ref,
    className: cls
  }, other, {
    children: children
  }));
});